
export default (() => {
    $(document).ready(function() {

    const options = {
            rootMargin: '200px',
            threshold: 0.0,
        };

    var imgObserver = new IntersectionObserver((entries, observer) => {
        for (var i = 0; i < entries.length; i++) { 
            const entry = entries[i];
            if (entry.intersectionRatio > 0.0) {
                const image = entry.target;
                image.setAttribute('src', image.getAttribute('data-image'));
                image.removeAttribute('data-image');
                observer.unobserve(entry.target);
            }
        }
    }, options);

    var bgObserver = new IntersectionObserver((entries, observer) => {
                for (var i = 0; i < entries.length; i++) { 
                    const entry = entries[i];
                    if (entry.intersectionRatio > 0.0) {
                        const image = entry.target;
                        image.style.backgroundImage = 'url('+ image.getAttribute('data-bg-image') +')';
                        image.removeAttribute('data-bg-image');
                        observer.unobserve(entry.target);
                    }
                }
            }, options);

    var videoObserver = new IntersectionObserver((entries, observer) => {
            for (var i = 0; i < entries.length; i++) { 
                const entry = entries[i];
                if (entry.intersectionRatio > 0.0) {
                    const video = entry.target;
                    video.setAttribute('src', video.getAttribute('data-video'));
                    video.removeAttribute('data-video');
                    observer.unobserve(entry.target);
                }
            }
        }, options);

        $('[data-bg-image]').each(function() {
            if(!$(this).data('bg-image')) {
                return;
            }

            bgObserver.observe($(this)[0])
        })


        $('[data-video]').each(function() {
            if(!$(this).data('video')) {
                return;
            }

            videoObserver.observe($(this)[0])
        })

        $('[data-image]').each(function() {
            if(!$(this).data('image')) {
                return;
            }

            imgObserver.observe($(this)[0])
        })
        
    })
});



// WEBPACK FOOTER //
// ./scripts/util/lazyload.js